module.exports = __webpack_public_path__ + "media/images/product/c_a-2b3cfb066d77ea74ee3ddaca252c565e.jpg";